import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getReviewsByProductId = async (productId) => {
  try {
    const response = await axios.get(`${BASE_URL}/review/product/${productId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching reviews by product ID:", error);
    throw error; 
  }
};

export const postReview = async (productId, userId, rating, reviewText, userName, userEmail, token) => {
  try {
    const payload = {
      product_id: productId,
      user_id: userId,
      rating: rating,
      review: reviewText,
      name: userName,
      email: userEmail
    };

    const response = await axios.post(`${BASE_URL}/review`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    return response.data;
  } catch (error) {
    console.error("Error posting review:", error.response?.data || error.message);
    throw error;
  }
};

export const getReviewsByUserId = async (userId) => {
  try {
    const response = await axios.get(`${BASE_URL}/review/user/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching reviews by user ID:", error.response?.data || error.message);
    throw error;
  }
};
